import { render, staticRenderFns } from "./ProductShowInventory.vue?vue&type=template&id=a76135c2&"
import script from "./ProductShowInventory.vue?vue&type=script&lang=js&"
export * from "./ProductShowInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports